import PropTypes from 'prop-types';

// Goal PropTypes
export const GoalPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  user_id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  duration_type: PropTypes.oneOf(['SHORT', 'MEDIUM', 'LONG']).isRequired,
  start_date: PropTypes.string.isRequired,
  end_date: PropTypes.string.isRequired,
  target: PropTypes.number.isRequired,
  progress: PropTypes.number.isRequired,
  origin: PropTypes.oneOf(['HANA', 'PATIENT']).isRequired,
  status: PropTypes.oneOf(['ACTIVE', 'COMPLETED', 'CANCELLED', 'OVERDUE']).isRequired,

  // Streak tracking fields
  current_streak: PropTypes.number,
  longest_streak: PropTypes.number,
  last_check_in_date: PropTypes.string,

  // Category field
  category: PropTypes.string,

  created_at: PropTypes.string,
  updated_at: PropTypes.string,
});

// FormattedGoal PropTypes
export const FormattedGoalPropType = PropTypes.shape({
  ...GoalPropType.isRequired,
  category: PropTypes.string.isRequired,
  difficulty: PropTypes.oneOf(['hard']),
  term: PropTypes.oneOf(['short term', 'medium term', 'long term']),
  source: PropTypes.oneOf(['Hana Suggested', 'Personal']).isRequired,
  currentWeeklyStreak: PropTypes.number, // Maps to current_streak
  thisWeekProgress: PropTypes.number,
  weeklyTarget: PropTypes.number,
});
